const isLocalHost = process.env.NODE_ENV === "development";

const BASE_API_URL = isLocalHost
  ? "http://localhost:3002"
  : "https://musictierlist.com";
const BASE_SITE_URL = isLocalHost
  ? "http://localhost:3000"
  : "https://musictierlist.com";
const BASE_URL = isLocalHost ? "localhost" : "musictierlist.com";
const PORT = isLocalHost ? 3000 : 80;
const SERVER_PORT = 3002; // Usually remains the same

module.exports = {
  BASE_API_URL,
  BASE_SITE_URL,
  BASE_URL,
  PORT,
  SERVER_PORT,
};
